import { Component, OnInit } from '@angular/core';
import { User } from '../_model/login';
import { RecoveryService } from '../_services/recovery.service';

@Component({
    selector: 'app-recovery',
    templateUrl: './recovery.component.html',
    styleUrls: ['./recovery.component.less'],
    standalone: false
})
export class RecoveryComponent implements OnInit {

  constructor(private recovery: RecoveryService) { }

  cha: string = "";

  login: User = new User();

  pass: string = "";
  cpass: string = "";

  ngOnInit() {
    var param = new URLSearchParams(location.search);
    if(param.get("data") == null || param.get("data") == undefined)
      location.href = ""; 
    this.cha = param.get('data').replaceAll(" ","+");
    this.recovery.chanllenge(this.cha).subscribe((data: User) => {
      this.login = new User(data);
    }, err => {
      location.href = "";
    });
  }

  send() {
    if(this.pass != this.cpass)
      return;
    if(this.login.id == 0 || this.login.id == -1)
      return;
    this.recovery.password(this.login.id, this.pass).subscribe(() => {
      location.href = "";
    });
  }

}
